import { render } from "./SetProduct.vue?vue&type=template&id=d5bc13da"
import script from "./SetProduct.vue?vue&type=script&lang=js"
export * from "./SetProduct.vue?vue&type=script&lang=js"

import "./SetProduct.vue?vue&type=style&index=0&id=d5bc13da&lang=css"
script.render = render

export default script